"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles = require('./Label.module.scss');
const Label = ({ children, className = '', hidden, htmlFor, isRequired = true, hideOptionalText, label, isHorizontal, RootComponent = 'label', classes: { root: rootClassName = '', labelTextWrapper = '' } = {}, }) => (react_1.default.createElement(RootComponent, Object.assign({ className: (0, classnames_1.default)(styles.root, {
        [styles.rootHorizontal]: isHorizontal,
        [className]: !!className,
        [rootClassName]: !!rootClassName,
    }) }, (RootComponent === 'label' && { htmlFor })),
    react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.labelTextWrapper, {
            [styles.hidden]: hidden,
            [styles.labelTextWrapperHorizontal]: isHorizontal,
            [labelTextWrapper]: !!labelTextWrapper,
        }) },
        label,
        !isRequired && !hideOptionalText && react_1.default.createElement("span", { className: styles.optional }, " (optional)")),
    children));
exports.default = (0, react_1.memo)(Label);
//# sourceMappingURL=Label.js.map